import InspireBigBetsBrowsePage from "@faire/prototype-playground/workspace/vs/inspire-big-bets-browse";
import { Route, Switch } from "react-router-dom";

import { withCompass } from "../../components/compass/withCompass";

const HolidayHubsPage = withCompass(
  () => import("@faire/prototype-playground/workspace/vs/holiday-hubs")
);

const RetailerCommandCenterPage = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/vs/retailer-command-center")
);

const SocialProofHeartAndCartsPage = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/vs/social-proof-heart-and-carts")
);

const RationaleHubsProductTilePage = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/vs/rationale-hubs-product-tile")
);

export function VictoriaSchusterRoutes() {
  return (
    <Switch>
      <Route path="/vs/holiday-hubs" component={HolidayHubsPage} />
      <Route
        path="/vs/inspire-big-bets-browse"
        component={InspireBigBetsBrowsePage}
      />
      <Route
        path="/vs/retailer-command-center"
        component={RetailerCommandCenterPage}
      />
      <Route
        path="/vs/social-proof-heart-and-carts"
        component={SocialProofHeartAndCartsPage}
      />
      <Route
        path="/vs/rationale-hubs-product-tile"
        component={RationaleHubsProductTilePage}
      />
    </Switch>
  );
}

export const slug = "vs";
